<template>
  <main class="container my-2 mt-3" style="max-width: 1000px">
    <SimuladorStep v-if="!loading" :step="4" :valor="plano.valorMensal"
      :periodicidade="plano.modeloCobranca.periodicidade">
    </SimuladorStep>
    <div class="d-flex row mt-1" v-if="!loading">
      <div class="col">

        <div v-if="!infoCompraFinalizada" class="mt-5  text-center">
          <p class="mt-5">
            <i class="fa-regular fa-circle-check icon"></i>
          </p>
          <p class="mt-3" style="font-size:18px;"><strong>Sua assinatura foi realizada com sucesso!</strong>
          </p>
          <p class="mt-3">
            Agradecemos pela sua assinatura e esperamos que aproveite muito o nosso conteúdo.

          </p>
        </div>

        <div  v-if="infoCompraFinalizada" class="px-4 py-3 mb-4 mt-1 shadow" >
          <div v-if="infoCompraFinalizada" v-html="infoCompraFinalizada"></div>
        </div>

      </div>
    </div>
    <Loading v-if="loading"></Loading>
  </main>
</template>

<script>
import Loading from "@/components/Loading.vue";
import SimuladorStep from "@/components/assinaturas/SimuladorStep.vue";
import { APIService } from "../../APIService";
const apiService = new APIService();

import { SimuladorService } from "../../service/assinatura/SimuladorService";
const simuladorService = new SimuladorService();

export default {
  name: "SimuladorStep4",
  props: [],
  components: { Loading, SimuladorStep },
  data() {
    return {
      loading: false,
      plano: {
        modeloCobranca: {}
      },
      erro: null,
      infoCompraFinalizada: null,
    };
  },
  mounted() {
    const _plano = localStorage.getItem("simulacao-plano");
    if (_plano) {
      this.plano = JSON.parse(_plano);
    }
    this.obterFuncionalidades();
  },
  methods: {
    formatPeriodicidade(periodicidade) {
      return simuladorService.formatPeriodicidade(periodicidade);
    },
    obterFuncionalidades() {
      this.loading = true;
      apiService
        .getFuncionalidadeV2(window.APP_ORIGIN)
        .then((res) => {
         const funcionalidades =
            res.filter((e) => {
              return "MICROAPP_TEXTOS" == e.funcionalidade;
            });

          const valorString = funcionalidades[0].valorString;
          this.funcionalidades = JSON.parse(valorString);

          const infoCompraFinalizada = this.funcionalidades.find(objeto => objeto.codigoMicroapp === "MAPP_COMPRA_FINALIZADA");
          if (infoCompraFinalizada && infoCompraFinalizada.ativo) {
            const currentRoute = this.$route.path;
              let rotaCorresponde = false;
              for (const pagina of infoCompraFinalizada.paginas) {
                  if (currentRoute.includes(pagina)) {
                      rotaCorresponde = true;
                      break;
                  }
              }

              if (rotaCorresponde) {
                this.infoCompraFinalizada = infoCompraFinalizada.html;
              }
          }
          this.loading = false;
        })
        .catch((error) => {
          console.log("log error", error);
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.icon {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 56px;
  transition: 0.5s;
  color: var(--cor-secundaria);
  overflow: hidden;
}
</style>
